import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'a-spinner',
    templateUrl: './a-spinner.component.html',
    styleUrls: ['./a-spinner.component.scss'],
    standalone: false
})
export class ASpinnerComponent implements OnInit {

  @Input()
  public size: string = 'medium';

  constructor() { }

  ngOnInit(): void {
  }

}
